module.exports = __webpack_public_path__ + "media/images/emblems/Staldenried_Wappen-49a681aa7aa332a60da9f51006226707.png";